import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const sandboxBrowserWeb: PluginWebManifest = {
  // sandbox-browser is a no-page plugin — it only contributes a
  // "Tunnel" agent tab. The overview card is written by hand so
  // the plugin detail page renders a rich About section; `to`
  // targets the canonical plugin detail page since there is no
  // standalone page to deep-link to.
  overviewCards: [
    {
      to: '/org/plugins/sandbox-browser',
      label: 'Sandbox Browser',
      icon: 'Globe',
      description: 'Embedded browser for any port on an agent devbox.',
      details:
        'Opens an in-app browser tab on every agent that tunnels straight into the devbox, so you can hit any port and path the agent is serving — dev servers, dashboards, preview URLs — without leaving Reflex or setting up SSH.',
      features: [
        '"Tunnel" tab on every agent detail page',
        'Tunnelled into the live agent devbox — no port forwarding to configure',
        'Visit any port and path the agent serves',
        'Useful for inspecting dev servers, preview URLs, and dashboards',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: 'sandbox-browser',
      label: 'Tunnel',
      icon: 'Globe',
      componentPath: '@reflex/plugin-sandbox-browser/web/SandboxBrowserTab',
    },
  ],
  marketingPreviews: [
    {
      id: 'sandbox-browser-panel',
      label: 'Sandbox browser agent panel',
      description:
        'How the sandbox browser surfaces inside an agent — the in-app browser tab loaded against a sample page on the agent devbox.',
      surface: 'panel',
      componentPath: '@reflex/plugin-sandbox-browser/web/SandboxBrowserTabPreview',
    },
  ],
};
